module.exports = __webpack_public_path__ + "static/img/10004 (2).15fe714.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10004 (2).webp
// module id = 3dDu
// module chunks = 14